import { useState, useEffect, useCallback } from 'react';
import './Games.css';

export default function CloverGame({ theme = 'default' }) {
    const [clovers, setClovers] = useState([]);
    const [score, setScore] = useState(0);
    const [message, setMessage] = useState('');
    const [foundIndexes, setFoundIndexes] = useState([]);

    const generateClovers = useCallback(() => {
        const newClovers = Array(8).fill('three');
        const fourLeafCount = 1 + Math.floor(Math.random() * 2);
        const positions = [];

        while (positions.length < fourLeafCount) {
            const pos = Math.floor(Math.random() * 8);
            if (!positions.includes(pos)) {
                positions.push(pos);
                newClovers[pos] = 'four';
            }
        }

        setClovers(newClovers);
        setFoundIndexes([]);
        setMessage('');
    }, []);

    useEffect(() => {
        generateClovers();
    }, [generateClovers]);

    const handleClick = (e, index) => {
        e.preventDefault();
        if (foundIndexes.includes(index)) return;

        if (clovers[index] === 'four') {
            setScore(prev => prev + 30);
            setMessage('🎉 네잎클로버 발견! +30점');
            setFoundIndexes(prev => [...prev, index]);

            const allFourLeaf = clovers.reduce((acc, c, i) => {
                if (c === 'four') acc.push(i);
                return acc;
            }, []);

            if (allFourLeaf.every(i => [...foundIndexes, index].includes(i))) {
                setTimeout(generateClovers, 1000);
            }
        } else {
            setMessage('세잎클로버예요~');
            setTimeout(() => setMessage(''), 800);
        }
    };

    const themeClass = theme === 'daetong' ? 'theme-daetong' : theme === 'lighthouse' ? 'theme-lighthouse' : '';

    return (
        <div className={`game-container ${themeClass}`}>
            <div className="game-title">🍀 네잎클로버를 찾으세요!</div>
            <div className="game-score">발견: {score}점</div>
            <div className="clover-grid">
                {clovers.map((clover, index) => (
                    <div
                        key={index}
                        className={`clover-item ${foundIndexes.includes(index) ? 'found' : ''}`}
                        onClick={(e) => handleClick(e, index)}
                        onTouchEnd={(e) => handleClick(e, index)}
                    >
                        {foundIndexes.includes(index) && clovers[index] === 'four' ? '🍀✨' : '🍀'}
                    </div>
                ))}
            </div>
            <div className="game-message">{message}</div>
        </div>
    );
}
